import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import * as firebase from 'firebase';

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.css']
})
export class PostsComponent implements OnInit {

  month: string = "";

  allPosts: Array<any> = [];

  posts: Array<any> = [];

  users: any = {};

  query: string = "";

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.month = params['month'];
      if (this.month) {
        this.filter();
      } else {
        this.getPosts();
      }
    });

  }

  filter() {
    var monthNum = this.getMonth(this.month);

    var date = new Date();

    date.setMonth(monthNum, 1);
    date.setHours(0, 0, 1);

    var start = date.getTime();

    date.setMonth(monthNum + 1, 0);

    date.setHours(23, 59, 59);

    var end = date.getTime();

    this.getPosts(start, end);
  }

  getPosts(start?, end?) {
    var ref: any = firebase.database().ref('posts');

    if (start) {
      ref = ref.orderByChild("timestamp")
        .startAt(start)
        .endAt(end);
    }

    ref.once("value")
      .then(snapshot => {
        var data = snapshot.val();

        if (!data) {
          this.posts = [];
          return;
        }

        for (var key in data) {
          var temp = data[key];

          temp.key = key;

          if (!this.users[temp.uid]) {
            this.users[temp.uid] = {
              uid: temp.uid
            }

            this.getUser(temp.uid);
          }

          this.posts.push(temp);
          this.allPosts.push(temp);
        }

      })
      .catch(err => {
        alert(err.message);
        console.log(err);
      });
  }

  getUser(uid) {
    firebase.database().ref(`/users/${uid}`)
      .once("value")
      .then(snapshot => {
        var user = snapshot.val();

        this.users[uid] = user;
      })
  }

  toggleSuspend(index, status) {
    firebase.database().ref(`/posts/${this.posts[index].key}/isSuspended`).set(status);

    this.posts[index].isSuspended = status;
  }

  getMonth(month) {
    switch (month) {
      case 'Jan':
        return 0;
      case 'Feb':
        return 1;
      case 'Mar':
        return 2;
      case 'Apr':
        return 3;
      case 'May':
        return 4;
      case 'Jun':
        return 5;
      case 'Jul':
        return 6;
      case 'Aug':
        return 7;
      case 'Sep':
        return 8;
      case 'Oct':
        return 9;
      case 'Nov':
        return 10;
      case 'Dec':
        return 11;
      default:
        return -1;
    }
  }

  search() {
    if(!this.query) {
      this.posts = this.allPosts;
      return;
    }

    this.posts = [];

    this.allPosts.forEach(post => {
      if(this.users[post.uid].name.toLowerCase().indexOf(this.query.toLowerCase()) >= 0
      || post.placeName.toLowerCase().indexOf(this.query.toLowerCase()) >= 0) {
        this.posts.push(post);
      }
    });
  }

}
